import { render, staticRenderFns } from "./Dialpad.vue?vue&type=template&id=12bdf93c"
import script from "./Dialpad.vue?vue&type=script&lang=js"
export * from "./Dialpad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports